var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({ variant: 'info', title: 'Edit', placement: _vm.position }),expression:"{ variant: 'info', title: 'Edit', placement: position }",modifiers:{"hover":true}}],staticClass:"icon-button",attrs:{"icon":['fas', 'edit']}})
}
var staticRenderFns = []

export { render, staticRenderFns }